<template>
  <section>
        <template>
          <div class="row">
            <div class="col-10">
              <strong class="py-2">
                <b >{{ $t("lang.onBoarding." + value + "_prepend",this.$store.state.onboarding.lang) }} </b>

                <span v-if="value == 'what_we_created'" class="mr-1">{{$store.state.onboarding.productName}}, </span>
                <span v-if="value == 'we_propose'" class="mr-1">{{$store.state.onboarding.companyName}} </span>
                <span v-if="!editing" >
                  <span class="text-primary mr-1 border-bottom-1 border-style-dashed border-right-0  border-left-0 border-top-0" v-if="step1[value]"> {{ step1[value] }} </span>
                  <span class="text-secondary mx-1" v-else>_ _ _<i @click="open" class="icon-pencil text-primary cursor-pointer"></i></span>
                </span>
                <input v-if="editing" class="border-secondary border-style-dashed text-primary border-right-0  border-left-0 border-top-0 border-bottom-1  pt-0 w-100"
                  :placeholder='$t("lang.onBoarding." + value + "_example",this.$store.state.onboarding.lang)'
                  type="text" :value="step1[value]" @input="updateText"/>

                <br v-if="value2 == 'argument_1'"/>
                
                <span  v-if="value2" :class="editing ? 'w-100':''">

                  <span v-if="value2 == 'ref_2'">,</span>
                  <input v-if="editing" class="border-secondary border-style-dashed text-primary border-right-0  border-left-0 border-top-0 border-bottom-1  pt-0 w-100"
                  :placeholder='$t("lang.onBoarding." + value2 + "_example",this.$store.state.onboarding.lang)'
                  type="text" :value="step1[value2]" @input="updateText2"/>

                  <span v-if="!editing" >
                    <span class="text-primary mr-1 border-bottom-1 border-style-dashed border-right-0  border-left-0 border-top-0" v-if="step1[value2]"> {{ step1[value2] }} </span>
                    <span class="text-secondary mx-1" v-else>_ _ _<i @click="open" class="icon-pencil text-primary cursor-pointer"></i></span>  
                  </span>  
                  <b v-if="value2 != 'argument_2'" class="mr-1">  {{ $t("lang.filters.and",this.$store.state.onboarding.lang) }} </b>
                </span> 
                  <br v-if="value2 == 'argument_2'"/>
                
                <span  v-if="value3"  :class="editing ? 'w-100':''">

                  <input v-if="editing" class="border-secondary border-style-dashed text-primary border-right-0  border-left-0 border-top-0 pt-0 w-100"
                  :placeholder='$t("lang.onBoarding." + value3 + "_example",this.$store.state.onboarding.lang)'
                  type="text" :value="step1[value3]" @input="updateText3"/>
                  <span v-if="!editing" >
                    <span class="text-primary border-style-dashed border-right-0  border-left-0 border-top-0" v-if="step1[value3]"> {{ step1[value3] }} </span>
                    <span class="text-secondary mx-1 cursor-pointer" v-else>_ _ _<i @click="open" class="icon-pencil text-primary"></i></span><span class="d-inline">.</span>
                  </span>
                </span>
                  <b> {{ $t("lang.onBoarding." + value + "_apend",this.$store.state.onboarding.lang) }}</b>
              
              </strong>
             
            </div>
            <div class="col-2">
              <button  v-if="!editing" @click="open" class="btn  rounded-circle  cursor-pointer btn-sm btn-primary" type="button">
                <i class="icon-pencil"></i>
              </button>

              <button v-if="editing" @click="save" class="btn rounded-circle  cursor-pointer btn-sm btn-success" type="button">
                <i class="icon-check1"></i>
              </button>
            </div>
          </div>
        </template>
        
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      editing: false
      }
  },
   computed: {
    ...mapState({
      step1: state => state.onboarding.step1
    })
  },
  props: {
    productName: String,
    value: [String, Boolean],
    value2: [String, Boolean],
    value3: [String, Boolean],
    prePend: String,
    type: Number,
    subStep: Number,
  },

   methods: {
    ...mapActions("onboarding", {
      updateDescription: "updateDescription"
    }),
    save(){
      this.editing=false
      this.$emit("save")

    },
    open(){
      this.editing=true
    },
    updateText(e) {
      this.updateDescription({ field: this.value, value: e.target.value})
    },
    updateText2(e) {
      this.updateDescription({ field: this.value2, value: e.target.value})
    },
    updateText3(e) {
      this.updateDescription({ field: this.value3, value: e.target.value})
    },
  }
  }
</script>
<style>
.border-style-dashed{
  border-style: dashed;
  border:1px dashed;

}
</style>